module.exports = "/lucky-balls/img/regular_game/header_pinnbet.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_pinnbet.png
// module id = 1148
// module chunks = 0